module.exports = __webpack_public_path__ + "static/Forager2-3657090b4719d714ca3e5d2bc4e3d1bd.webp";